import { IdentifierDTO } from '@zazume/zzm-base';

export const OrganizationIntegrationsSettingsKeys = {
  base: 'organizationIntegrationsSettings',
  byOrganizationId: (organizationId: IdentifierDTO) => [OrganizationIntegrationsSettingsKeys.base, organizationId]
};
